var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Thumbnails50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2196F3",
    d: "M16 15c0 1.104-.896 2-2 2H8c-1.104 0-2-.896-2-2v-4c0-1.104.896-2 2-2h6c1.104 0 2 .896 2 2V15zM29 15c0 1.104-.896 2-2 2h-6c-1.104 0-2-.896-2-2v-4c0-1.104.896-2 2-2h6c1.104 0 2 .896 2 2V15zM42 15c0 1.104-.896 2-2 2h-6c-1.104 0-2-.896-2-2v-4c0-1.104.896-2 2-2h6c1.104 0 2 .896 2 2V15zM16 26c0 1.104-.896 2-2 2H8c-1.104 0-2-.896-2-2v-4c0-1.104.896-2 2-2h6c1.104 0 2 .896 2 2V26zM29 26c0 1.104-.896 2-2 2h-6c-1.104 0-2-.896-2-2v-4c0-1.104.896-2 2-2h6c1.104 0 2 .896 2 2V26zM42 26c0 1.104-.896 2-2 2h-6c-1.104 0-2-.896-2-2v-4c0-1.104.896-2 2-2h6c1.104 0 2 .896 2 2V26zM16 37c0 1.104-.896 2-2 2H8c-1.104 0-2-.896-2-2v-4c0-1.104.896-2 2-2h6c1.104 0 2 .896 2 2V37zM29 37c0 1.104-.896 2-2 2h-6c-1.104 0-2-.896-2-2v-4c0-1.104.896-2 2-2h6c1.104 0 2 .896 2 2V37zM42 37c0 1.104-.896 2-2 2h-6c-1.104 0-2-.896-2-2v-4c0-1.104.896-2 2-2h6c1.104 0 2 .896 2 2V37z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Thumbnails50);
export default __webpack_public_path__ + "static/media/icons8-thumbnails-50.304ade3f7ea2bceeb4383dfe8eaef5fc.svg";
export { ForwardRef as ReactComponent };